import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { MainDto } from '../../config/filePartyConfig'
import { FilePartyMetaDataDto } from '../../config/finance/invoiceConfig'
import BaseCombobox, { SubComboboxProps } from './BaseCombobox'
import { useSettings } from '../../hooks/useSettings'

type FilePartyType = MainDto | FilePartyMetaDataDto

type FilePartyGroupType = FilePartyType & {
    entities: FilePartyType[]
}

export default function FilePartyCombobox(props: SubComboboxProps<FilePartyType>): ReactElement {
    const { settings } = useSettings()

    const groupedParties = useMemo<FilePartyGroupType[]>(() => {
        const result: FilePartyGroupType[] = []
        if (props.entities) {
            const groups: Map<string, FilePartyGroupType> = props.entities.reduce((map: Map<string, FilePartyGroupType>, party: FilePartyType) => {
                const group: FilePartyGroupType = map.get(party.role) || { ...party, entities: [] }
                group.entities = [...group.entities, party].sort((a, b) => a.displayName.localeCompare(b.displayName))
                map.set(party.role, group)
                return map
            }, new Map<string, FilePartyGroupType>())

            groups.forEach(group =>
                result.push({ ...group, displayName: settings.filePartyRoles.find(role => role.type === group.role)?.label || group.role }),
            )
        }
        return result
    }, [props.entities])

    if (groupedParties.length > 1) {
        return (
            <BaseCombobox<FilePartyType, FilePartyGroupType>
                alphabetical
                isGroup={group => group['entities'] !== undefined}
                getGroupEntities={group => group.entities}
                getGroupLabel={group => group.displayName}
                getGroupValue={group => group.role}
                getEntityLabel={user => user.displayName}
                getEntityValue={user => user.id}
                placeholderKey={'base.userpicker.placeholder'}
                {...props}
                entities={groupedParties}
            />
        )
    }

    return (
        <BaseCombobox<FilePartyType>
            alphabetical
            getEntityLabel={user => user.displayName}
            getEntityValue={user => user.id}
            placeholderKey={'base.userpicker.placeholder'}
            {...props}
            entities={props.entities}
        />
    )
}
